/**
 * @generated SignedSource<<aeffd1f97fb296ba9312c370fda5cb82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Kind = "Assigment" | "FreeForAll";
export type EditLicenseModelInput = {
  clientMutationId?: string | null;
  licenseModelKind: Kind;
};
export type licenseSettings_EditLicenseModelMutation$variables = {
  input: EditLicenseModelInput;
};
export type licenseSettings_EditLicenseModelMutation$data = {
  readonly LicenseModel: {
    readonly editLicenseModel: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type licenseSettings_EditLicenseModelMutation = {
  response: licenseSettings_EditLicenseModelMutation$data;
  variables: licenseSettings_EditLicenseModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LicenseModelMutations",
    "kind": "LinkedField",
    "name": "LicenseModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "EditLicenseModelPayload",
        "kind": "LinkedField",
        "name": "editLicenseModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licenseSettings_EditLicenseModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licenseSettings_EditLicenseModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "45d8e51541cd69ffd01369184322224d",
    "id": null,
    "metadata": {},
    "name": "licenseSettings_EditLicenseModelMutation",
    "operationKind": "mutation",
    "text": "mutation licenseSettings_EditLicenseModelMutation(\n  $input: EditLicenseModelInput!\n) {\n  LicenseModel {\n    editLicenseModel(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "667a41c9ce53a39d30c6a9649f11690c";

export default node;
